import { BasicCalls } from '@/api/models'

class CloudCanteen extends BasicCalls {
    constructor() {
        super()
        this.apiRoot = 'frontend-api'
        this.apiVersion = 'public'
        this.apiBase = 'canteen'
    }
}

export { CloudCanteen }
